"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OwnedNftsVariable = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _VariableType = require("../VariableType");
class OwnedNftsVariable extends _VariableType.VarsValueVariableType {
  constructor() {
    super();
    (0, _defineProperty2.default)(this, "settings", OwnedNftsVariable.settings);
    (0, _defineProperty2.default)(this, "type", "owned-nfts");
    (0, _defineProperty2.default)(this, "label", "Owned NFTs");
    (0, _defineProperty2.default)(this, "description", "Load a list of NFTs owned by a wallet.");
  }
  dependencies(params, resolver) {
    let contract = resolver.resolveContract(params.contract);
    let wallet = resolver.resolveWallet(params.wallet);
    return {
      contract,
      wallet
    };
  }
  async value(deps, batcher) {
    if (!(deps !== null && deps !== void 0 && deps.contract) || !deps.wallet) {
      return null;
    }
    let items = await batcher.getOwnedNfts(deps.contract, deps.wallet);
    return items.map(it => it.tokenId);
  }
}
exports.OwnedNftsVariable = OwnedNftsVariable;
(0, _defineProperty2.default)(OwnedNftsVariable, "settings", {
  contract: {
    type: "var",
    variableType: "contract",
    title: "NFT Contract",
    description: "Contract to load an NFT item from."
  },
  wallet: {
    type: "var",
    variableType: ["wallet", "value", "contract"],
    description: "Wallet to load NFTs for."
  }
});
//# sourceMappingURL=OwnedNftsVariable.js.map